import { css } from 'styled-components'

export const userSelectNone = () => {
  return css`
    user-select: none;
  `
}
